import { Loader2 } from "lucide-react";
import { cn } from "@/lib/cn";

export interface SpinnerProps {
  /** Visual size — sm (16px) for inline/buttons, md (20px) standalone. */
  size?: "sm" | "md";
  className?: string;
  /** Accessible label; defaults to a generic "Загрузка". */
  label?: string;
}

const SIZES = {
  sm: 16,
  md: 20,
} as const;

/** Indeterminate spinner built on lucide `Loader2` with a `spin` animation. */
export function Spinner({ size = "sm", className, label = "Загрузка" }: SpinnerProps) {
  return (
    <Loader2
      role="status"
      aria-label={label}
      size={SIZES[size]}
      strokeWidth={2}
      className={cn("animate-spin", className)}
    />
  );
}
